module.exports = __webpack_public_path__ + "static/media/book.72e86d0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/book.jpg
// module id = 18
// module chunks = 0